/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import styled, { css } from 'styled-components';
import { Link } from '@chegg-ui/link';
import { visuallyHiddenCss } from '@chegg-ui/theme';
export var StyledSkipLink = styled(Link).withConfig({
  componentId: "sc-1bjoeui-0"
})(["", ""], function (_ref) {
  var showOnFocusOnly = _ref.showOnFocusOnly;
  return showOnFocusOnly ? css(["position:absolute;&:not(:focus){", "}"], visuallyHiddenCss) : '';
});